
//#4375 日付コントロール等のプルダウンが効かなくなる
//→#4352 flexGridの列幅変更の方が優先とのことでtouchモジュールを有効にします。
import '@grapecity/wijmo.touch';

import * as wijmo from '@grapecity/wijmo';
import * as wjcChart from '@grapecity/wijmo.chart';
import * as wjcInput from '@grapecity/wijmo.input';
import * as wjcNav from '@grapecity/wijmo.nav';
import * as wjcXlsx from '@grapecity/wijmo.xlsx';
import * as wjcGrid from '@grapecity/wijmo.grid';
import * as wjcGridDetail from '@grapecity/wijmo.grid.detail';
import * as wjcTransposed from '@grapecity/wijmo.grid.transposed';

import * as wjcGridFilter from '@grapecity/wijmo.grid.filter';
import * as wjcGridSearch from '@grapecity/wijmo.grid.search';
import * as wjcGridGroupPanel from '@grapecity/wijmo.grid.grouppanel';
import * as wjcGridCellMaker from '@grapecity/wijmo.grid.cellmaker';
import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
import * as wjcMultiRow from '@grapecity/wijmo.grid.multirow';
import { Selector, BooleanChecker } from '@grapecity/wijmo.grid.selector';

//import * as wjcCultureJa from '@grapecity/wijmo.cultures/wijmo.culture.ja';
import '@grapecity/wijmo.cultures/wijmo.culture.ja';//こうしないとちゃんと入らない

import '@grapecity/wijmo.touch';

//import * as GC from '@grapecity/spread-sheets';
import { Spread } from '@grapecity/spread-sheets';
import * as Excel from '@grapecity/spread-excelio';
import '@grapecity/spread-sheets-charts';
import '@grapecity/spread-sheets-shapes';
import '@grapecity/spread-sheets-print';

//import * as culture from '@grapecity/spread-sheets-resources-ja';
//import * as spreadCultureJa from '@grapecity/spread-sheets-resources-ja';
import '@grapecity/spread-sheets-resources-ja';

//FileSaver（ここでImportすれば、同時にPackされる。各業務Tsではなにも意識する必要は無い！）
import "file-saver";

// カルチャ設定
//Spread.Common.CultureManager.addCultureInfo("ja-jp", spreadCultureJa);
//GC.Spread.Common.CultureManager.culture('ja-jp');
Spread.Common.CultureManager.culture("ja-jp");

// ライセンス
const LicenseKeyWijmo = window.sessionStorage.getItem('licenseKeyWijmo');
const LicenseKeySpreadJS = window.sessionStorage.getItem('licenseKeySpreadJS');
wijmo.setLicenseKey(LicenseKeyWijmo);
//GC.Spread.Sheets.LicenseKey = LicenseKeySpreadJS;
//const Spread = GC.Spread;
Spread.Sheets.LicenseKey = LicenseKeySpreadJS;
//Excel.LicenseKey = licenseKeySpreadJS;
(<any>Excel).LicenseKey = LicenseKeySpreadJS;




//#862 Text値未設定のコンボボックスについて
//（value: 1, のテキストが空文字の場合）
//{
//    value: 1, text: ''
//    value: 2, text: 'い'
//    value: 3, text: 'う'
//    value: 4, text: 'え'
//}
//選択しても、空文字が表示されるわけでもなく
//value値の'1'が表示されてしまう

//【spreadJs Bug Fix】
//JavaScript
//------------------------------------
Spread.Sheets.CellTypes.ComboBox.prototype.format = function (value, format, cfColor, context) {
    if (value === null && value !== void 0) { return ''; }

    let itemValue = (<any>Spread.Sheets.CellTypes.ComboBox.prototype).getItemValue.apply(this, [value]);
    //var itemValue = Spread.Sheets.CellTypes.ComboBox.prototype.getItemValue.apply(this, [value]);
    return Spread.Sheets.CellTypes.Base.prototype.format.apply(this, [
        (itemValue !== null && itemValue !== void 0) ? itemValue : value,
        format,
        cfColor]);
}
//------------------------------------


//export { wijmo, wjcChart, wjcGrid, wjcXlsx, wjcGridFilter, wjcGridSearch, wjcGridGroupPanel, wjcGridCellMaker, Selector, BooleanChecker, wjcGridXlsx, wjcInput, wjcNav, wjcCultureJa, Spread, Excel };
export { wijmo, wjcChart, wjcGrid, wjcXlsx, wjcGridDetail, wjcTransposed, wjcGridFilter, wjcGridSearch, wjcGridGroupPanel, wjcGridCellMaker, Selector, BooleanChecker, wjcGridXlsx, wjcInput, wjcNav, Spread, Excel, wjcMultiRow };
